import Vue from 'vue'
import Router from 'vue-router'
Vue.use(Router)

export default new Router({
	routes: [{
			path: '/',
			name: 'Index',
			component: () => import('@/views/index/index')
		},
		{
			path: '/guanyu',
			name: 'Guanyu',
			component: () => import('@/views/guanyu/guanyu')
		},
		{
			path: '/404',
			component: () => import('@/views/404'),
			hidden: true
		},
		{
			path: '*',
			redirect: '/404',
			hidden: true
		}
	]
})



// WEBPACK FOOTER //
// ./src/router/index.js